<div class="process-status">
  <div *ngIf="(processStatuses$ | async) === null; else tableContent" class="loading-spinner">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: gray;"></i>
  </div>
  <ng-template #tableContent>
    <div class="detailed-queue">
      <small>
        <a href="{{temporalServer}}" target="_blank">Detailed Queue</a>
      </small>
    </div>
    <span *ngIf="processStatuses$ | async as processes">
      <p-table [value]="processes" [responsiveLayout]="'scroll'" class="p-datatable-sm">
        <ng-template let-process pTemplate="body" >
          <tr>
            <process-status-item [processStatus]="process"></process-status-item>
            <p-divider class="w-full p-0"></p-divider>
          </tr>
        </ng-template>
      </p-table>
    </span>
  </ng-template>
</div>
